__turbopack_context__.v({
  "chatSpacing": "chatlink-module-scss-module__FbBx6W__chatSpacing",
});
